import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance } from 'vue';
import IconWrapper from '../icon-wrapper/icon-wrapper.vue';
import IconCheck from '@white-label-icon/icon-check';
import IconAlert from '@white-label-icon/icon-alert';
import ModalCenter from '../modal-center/modal-center.vue';
import DotsLoader from '../dots-loader/dots-loader.vue';
import { formatWithLocale, DATE_TIME_FORMATS } from '@white-label-helper/date-utilities';
import { formatPrice } from '@white-label-helper/helper-payment';
import { getAppVariable } from '@white-label-helper/get-app-variable';


export default /*#__PURE__*/_defineComponent({
  __name: 'modal-extend-booking',
  props: {
  newExitDate: {
    type: String,
    default: '',
  },
  price: {
    type: Number,
    default: 0,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  isExtendAvailable: {
    type: Boolean,
    default: false,
  },
},
  emits: ['continue', 'edit-exit', 'cancel'],
  setup(__props, { emit }) {

const instance = getCurrentInstance();
const proxy = instance?.proxy as Vue;





const exitDate = computed(() => {
  if (!proxy.newExitDate) {
    return '';
  }

  try {
    return formatWithLocale(
      new Date(proxy.newExitDate),
      getAppVariable('poi.country.code') === 'US'
        ? DATE_TIME_FORMATS.weekday_month_day_year_am_pm_lower_case
        : DATE_TIME_FORMATS.weekday_month_day_year_time_24hr_lower_case,
      proxy.$i18n.locale
    );
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
});

const onContinueHandler = () => emit('continue');
const onEditExitHandler = () => emit('edit-exit');
const onCancelHandler = () => emit('cancel');

return { __sfc: true,instance, proxy, emit, exitDate, onContinueHandler, onEditExitHandler, onCancelHandler, IconWrapper, IconCheck, IconAlert, ModalCenter, DotsLoader, formatPrice }
}

})